module.exports = __webpack_public_path__ + "static/media/isoCeritifiedR.9f7f7d48.PNG";